export enum PeriodPriceType {
    adultSingle = 'adult_single',
    adultDouble = 'adult_double',
    adultTriple = 'adult_triple',
    childBed = 'child_bed',
    childNoBed = 'child_no_bed',
    infant = 'infant',
    joinLand = 'join_land',
}
